/* global GoogleMapsLoader*/

import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import $ from "jquery";

function extractAddress(results) {
    const addresObj = { postal_code: null, street_number: null, route: null };

    Object.values(results[0].address_components).forEach(
        addressComponent => Object.keys(addresObj).forEach(
            (key) => {
                if (addressComponent.types.indexOf(key) >= 0) {
                    addresObj[key] = addressComponent.long_name;
                }
            },
        ),
    );

    return addresObj;
}

export default class CollectionPointsController extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            address: this.props.address,
            value: this.props.value,
            view: "map",
            markers: this.props.markers,
        };
    }

    componentWillMount() {
        $("#"+this.props.id).remove();
    }

    componentDidMount() {
        if (typeof GoogleMapsLoader === "undefined") {
            return;
        }
        GoogleMapsLoader.KEY = this.props.apiKey;
        GoogleMapsLoader.LIBRARIES = this.props.libraries;
        GoogleMapsLoader.LANGUAGE = this.props.language;
        GoogleMapsLoader.REGION = this.props.region;
        GoogleMapsLoader.load((google) => {
            this.google = google;
            this.geocoder = new google.maps.Geocoder();
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if (typeof this.geocoder !== "undefined" && this.state.view !== "map" && nextState.address !== this.state.address) {
            this.geocoder.geocode({ address: nextState.address }, (results, status) => {
                if (status === this.google.maps.GeocoderStatus.OK) {
                    this.onChangeLocation(extractAddress(results), results[0].geometry.location);
                }
            });
        }
    }

    onChangeLocation(address) {
        $.ajax({
            url: this.props.url,
            method: "GET",
            data: address,
            dataType: "json",
            success: (result) => {
                if (typeof result.error === "undefined") {
                    this.setState({ error: null, markers: result });
                } else {
                    this.setState({ error: result.error });
                }
            },
        });
    }

    render() {
        const CollectionPointsView = ComponentRegistry.get(this.props.view);

        return (
          <CollectionPointsView
            {...this.props} {...this.state}
            onSwitchView={value => this.setState({ view: value })}
            onSearch={value => this.setState({ address: value, error: null })}
            onLocationChange={address => this.onChangeLocation(address)}
            onChange={value => this.setState({ value })}
          >
            <input type="hidden" name={this.props.name} id={this.props.id} value={JSON.stringify(this.state.value)} />
          </CollectionPointsView>
        );
    }
}

CollectionPointsController.propTypes = {
    view: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    markers: PropTypes.arrayOf(PropTypes.shape({})),
    address: PropTypes.string,
    libraries: PropTypes.arrayOf(PropTypes.string),
    apiKey: PropTypes.string.isRequired,
    language: PropTypes.string,
    region: PropTypes.string,
};

CollectionPointsController.defaultProps = {
    view: "CheckoutViewsCollectionPointsView",
    markers: [],
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Checkout/Controllers/CollectionPointsController.jsx